;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .constant('VULNERABILITY_TYPE', {
      ORG: 'ORGANIZATION',
      APP: 'APPLICATION',
      SERVER: 'SERVER'
    })
    .constant('VULNERABILITY_SUBSTATUS', [
      {
        value: 'URL',
        text: 'URL is only accessible by trusted power users',
        translationId: 'detail_vulnerabilitySubstatus_trustedURL'
      },
      {
        value: 'FP',
        text: 'False positive',
        translationId: 'detail_vulnerabilitySubstatus_falsePositive'
      },
      {
        value: 'SC',
        text: 'Goes through an internal security control',
        translationId: 'detail_vulnerabilitySubstatus_internalControl'
      },
      {
        value: 'EC',
        text: 'Attack is defended by an external control',
        translationId: 'detail_vulnerabilitySubstatus_externalControl'
      },
      {
        value: 'OT',
        text: 'Other',
        translationId: 'detail_vulnerabilitySubstatus_other'
      }
    ])
    .constant('VULNERABILITY_STATUS', [
      'Confirmed',
      'Suspicious',
      'NotAProblem',
      'Remediated',
      'AutoRemediated',
      'Reported',
      'Fixed',
      'tracked',
      'untracked'
    ])
    /*TODO i18n-002*/
    .constant('VULN_STATUS', [
      {
        value: 'Confirmed',
        label: 'Confirmed',
        translationId: 'title_vulnerabilityStatusConfirmed'
      },
      {
        value: 'Suspicious',
        label: 'Suspicious',
        translationId: 'title_vulnerabilityStatusSuspicious'
      },
      {
        value: 'NotAProblem',
        label: 'Not a Problem',
        translationId: 'title_vulnerabilityStatusNotProblem'
      },
      {
        value: 'Remediated',
        label: 'Remediated',
        translationId: 'title_vulnerabilityStatusRemediated'
      },
      {
        value: 'AutoRemediated',
        label: 'Remediated - Auto-Verified',
        translationId: 'title_vulnerabilityStatusAutoRemediated'
      },
      {
        value: 'Reported',
        label: 'Reported',
        translationId: 'title_vulnerabilityStatusReported'
      }
    ])
    .constant('VULN_STATUS_FIXED', {
      value: 'Fixed',
      label: 'Fixed',
      translationId: 'title_vulnerabilityStatusFixed'
    })
    .constant('VULN_STATUS_NOTAPROBLEM', {
      value: 'NotAProblem',
      label: 'Not a Problem',
      translationId: 'title_vulnerabilityStatusNotProblem'
    })
    .constant('VULN_OPEN_STATUSES', [
      {
        value: 'Confirmed',
        label: 'Confirmed',
        translationId: 'title_vulnerabilityStatusConfirmed'
      },
      {
        value: 'Suspicious',
        label: 'Suspicious',
        translationId: 'title_vulnerabilityStatusSuspicious'
      },
      {
        value: 'Reported',
        label: 'Reported',
        translationId: 'title_vulnerabilityStatusReported'
      }
    ])
    .constant('VULN_CLOSED_STATUSES', [
      {
        value: 'NotAProblem',
        label: 'Not a Problem',
        translationId: 'title_vulnerabilityStatusNotProblem'
      },
      {
        value: 'Remediated',
        label: 'Remediated',
        translationId: 'title_vulnerabilityStatusRemediated'
      },
      {
        value: 'Fixed',
        label: 'Fixed',
        translationId: 'title_vulnerabilityStatusFixed'
      }
    ])
    .constant('VULN_STATUS_TYPE', {
      CONFIRMED: 'Confirmed',
      SUSPICIOUS: 'Suspicious',
      NOTAPROBLEM: 'NotAProblem',
      REMEDIATED: 'Remediated',
      AUTOREMEDIATED: 'AutoRemediated',
      REPORTED: 'Reported',
      FIXED: 'Fixed'
    })
})()
